import type { MakeCall } from './createMakeCall';
import type { ListingExclusion } from './types/Listing';
import type { ListingExclusionsResponse } from './getListingExclusions';

export interface ListingExclusionsPayload {
  dates: ListingExclusion[];
  adjustDates?: boolean;
  actionToken?: string;
}

const addListingExclusions =
  (makeCall: MakeCall) =>
  (
    listingId: number,
    { dates, adjustDates = true, actionToken }: ListingExclusionsPayload,
  ) =>
    makeCall<ListingExclusionsResponse>(
      'POST',
      `/api/v2/listing/${listingId}/exclusions`,
      {
        data: {
          dates,
          adjustDates,
          actionToken,
        },
      },
    );

export { addListingExclusions };
